import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../common/html/element'
import { CustomPrice } from '../../../../common/order/customPrice'
import classes from '../../../index.module.scss'

export const Price = ({ title, oldPrice, price, appendStyle }) => {
  return (
    <div className={classes.upgradeAccRowContainer} style={{ ...appendStyle }}>
      <Element className={[classes.title, 'fw600'].join(' ')}>
        <Translate value={title} />
      </Element>
      <div className="flexColumn">
        <CustomPrice
          oldPrice={oldPrice}
          value={price}
          style={{
            color: '#2C73E8',
            fontSize: 14,
            fontWeight: 600,
            marginLeft: 5,
          }}
          className={classes.w300}
        />
      </div>
      <div style={{ paddingLeft: 2 }}></div>
    </div>
  )
}
